import * as Styles from './VerticalBar.styles';

type BarType = {
  name: string;
  color: string;
  total: number;
  percentage: number;
};

type VerticalBarType = {
  data: BarType[];
};

export default function VerticalBar({ data }: VerticalBarType): JSX.Element {
  return (
    <Styles.ChartArea isCentered={data.length > 3}>
      {data.map((d, index) => {
        return (
          <Styles.Container key={index.toString()}>
            <Styles.BarArea>
              <Styles.Bar color={d.color} percentage={d.percentage}>
                <Styles.Number>{d.total}</Styles.Number>
              </Styles.Bar>
            </Styles.BarArea>
            <Styles.Footer>
              <Styles.CustomUserInitials firstName={d.name} />
              <Styles.Name>{d.name.split(' ')[0]}</Styles.Name>
            </Styles.Footer>
          </Styles.Container>
        );
      })}
    </Styles.ChartArea>
  );
}
